import React, { useEffect, useRef, useState, useContext, useMemo } from "react";
import PanoramaContext from "./Context";

const HOTSPOT_TYPE = {
  WALK_WAY: 1,
  INFO: 2,
  VOICE_MEMO: 3,
  PICTURE: 4,
};

var voiceMemoPlayer = new Audio();

const ToolTipInfo = () => {
  const { tooltipInfo, closeOverlay } = useContext(PanoramaContext);

  const { title, desc, type, file } = tooltipInfo;

  useEffect(() => {
    if (type === HOTSPOT_TYPE.VOICE_MEMO) {
      voiceMemoPlayer = new Audio(file);
      voiceMemoPlayer.play();
    }

    return () => {
      if (type === HOTSPOT_TYPE.VOICE_MEMO) voiceMemoPlayer?.pause();
    };
  }, []);

  const handleCloseClick = () => {
    if (type === HOTSPOT_TYPE.VOICE_MEMO && voiceMemoPlayer?.played)
      voiceMemoPlayer?.pause();

    closeOverlay();
  };

  return (
    <div className="pannellum-hotspot-tooltip">
      <div className="pannellum-hotspot-tooltip-container">
        <div className="pannellum-hotspot-tooltip-container-header">
          <h2 className="pannellum-hotspot-tooltip-container-header__title">
            {title}
          </h2>
          <div
            className="pannellum-hotspot-tooltip-container-header__close"
            onClick={handleCloseClick}
          >
            Close
          </div>
        </div>
        <div className="pannellum-hotspot-tooltip-container-content">
          {desc && (
            <p className="pannellum-hotspot-tooltip-container-content__desc">
              {desc}
            </p>
          )}
          {type === HOTSPOT_TYPE.PICTURE && (
            <img
              className="pannellum-hotspot-tooltip-container-content__image"
              alt=""
              src={file}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ToolTipInfo;
